import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _TaskDropdownItemsComponent;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { array, fn, concat } from '@ember/helper';
import perform from 'ember-concurrency/helpers/perform';
import tWithDefault from 'core/helpers/t-with-default';
import transitionToForc from 'core/helpers/transition-to-forc';
import { t } from 'ember-intl';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class TaskDropdownItemsComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "processTask", _buildTask(() => ({
      context: this,
      generator: function* (task1, actionTaken1) {
        this.args.onTaskProcessedOrShifted?.();
        yield task1.processTask(actionTaken1);
      }
    }), null, "processTask", null));
    _defineProperty(this, "shiftTask", _buildTask(() => ({
      context: this,
      generator: function* (task1, unit1) {
        yield task1.shift(1, unit1);
        this.args.onTaskProcessedOrShifted?.();
      }
    }), null, "shiftTask", null));
  }
}
_TaskDropdownItemsComponent = TaskDropdownItemsComponent;
setComponentTemplate(precompileTemplate("\n    {{#each (array \"completed\" \"not-completed\" \"irrelevant\") as |actionTaken|}}\n      <@dropdown.Item @onClick={{fn (perform this.processTask) @task actionTaken}} @key={{actionTaken}}>\n        {{tWithDefault (concat \"task.actions.\" actionTaken) actionTaken}}\n      </@dropdown.Item>\n    {{/each}}\n\n    <@dropdown.Divider />\n\n    <@dropdown.Item @onClick={{fn (perform this.shiftTask) @task \"days\"}} @key=\"shift-day\">\n      {{t \"task.actions.shift-day\"}}\n    </@dropdown.Item>\n    <@dropdown.Item @onClick={{fn (perform this.shiftTask) @task \"weeks\"}} @key=\"shift-week\">\n      {{t \"task.actions.shift-week\"}}\n    </@dropdown.Item>\n    <@dropdown.Item @onClick={{fn (perform this.shiftTask) @task \"months\"}} @key=\"shift-month\">\n      {{t \"task.actions.shift-month\"}}\n    </@dropdown.Item>\n\n    {{#unless @hideShiftOther}}\n      <@dropdown.Item @onClick={{transitionToForc \"task\" \"edition-form\" patient=@task.patient sourceJeId=@task.id}} @key=\"shift-other\">\n        {{t \"task.actions.shift-other\"}}\n      </@dropdown.Item>\n    {{/unless}}\n  ", {
  strictMode: true,
  scope: () => ({
    array,
    fn,
    perform,
    tWithDefault,
    concat,
    t,
    transitionToForc
  })
}), _TaskDropdownItemsComponent);